let endpointUrl = '/webprotege';
let webprotegeUrl = '/webprotege';
let options = {endpointUrl, credentials: 'include', mode: 'cors'};

/** Параметр, содержащий адрес сервера WebProteget */
const webprotege_server_url = "webprotege.server.url";
/** Параметр, содержащий AkiKey webprotege */
const webprotege_api_key ="webprotege.api.key";
const id_settings = "settings";

/** В HTML странице должен быть элемент с id_settings, в котором атрибут webprotege.url содержит адрес WebProtege
 *  например  <div class="display: none;" id="settings"
 *   webprotege.url="https://stat.semanticpro.org/webprotege" 
 *   webprotege.api.key="f2d7618e-d289-4168-98fd-450104b2698b"></div>
 */
const loadWebProtegeSettings = settings =>{
	const node = document.getElementById(id_settings);
	if (!node){
		alert("Параметры соединения c WebProtege отсутствуют!\nБудут использованы настройки по умолчанию!\nОбратитесь к администратору системы.")
		return;
	}
    if (node.getAttribute(webprotege_server_url)==null){
		console.warn("WebProteget url not setting ("+webprotege_server_url+" not found)!");
	} else {
        settings.webprotegeUrl = node.getAttribute(webprotege_server_url);
        settings.endpointUrl = node.getAttribute(webprotege_server_url);
        settings.options.endpointUrl = node.getAttribute(webprotege_server_url);
    }

    if (node.getAttribute(webprotege_api_key)==null)
		console.debug("WebPpoteget API not setting ("+webprotege_api_key+" not found)!");
	 else 
        settings.apiKey = node.getAttribute(webprotege_api_key);
        
    console.log("WebProtege settings", settings);
	return settings;
}

let settings = loadWebProtegeSettings({
    endpointUrl,
    loadTimeout: 300000,
    DATE_TIME_FORMAT: 'DD.MM.YYYY HH:mm',
    DATE_FORMAT: 'DD.MM.YYYY',
    defaultLocale: 'ru',
    webprotege_username: 'user@webprotege.local',
    virtuoso_password: 'user001',
    options,
    apiKey: "00000000-0000-0000-0000-000000000000"
});

export default settings;
